import cookie from 'react-cookies';
import AWS from "aws-sdk"
import { UploadToAwsReturnData } from './interfaces/interfaces';


export const getToken = () => {
    return cookie.load("cbta_")
}

export function getKey(n: number = 15) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    let m = n || 15;

    for (let i = 0; i < m; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

export const addRandomStringToFileName = (fileName: string, n: number = 15, rename: boolean = false) => {
    const randomString = getKey(n);
    const extension = fileName.split('.').pop(); // Get the file extension
    let baseFileName = fileName.replace(`.${extension}`, ''); // Remove the extension
    if (rename) {
        baseFileName = "file"
    }
    const newFileName = `${baseFileName}_${randomString}.${extension}`;
    return newFileName;
};

export const UploadtoAWS = async (file: File, onProgress: (percent: number) => void, rename: boolean = false): Promise<UploadToAwsReturnData | null> => {
    let fileName = addRandomStringToFileName(file.name);
    if (rename) {
        fileName = addRandomStringToFileName(file.name, 30, rename);
    }

    // console.log('fileName :', fileName)
    const s3 = new AWS.S3({
        accessKeyId: process.env.REACT_APP_CURIOBITES_AWS_ACCESS_KEY_ID,
        secretAccessKey: process.env.REACT_APP_CURIOBITES_AWS_SECRET_ACCESS_KEY,
        region: process.env.REACT_APP_CURIOBITES_AWS_REGION,
    });

    const bucketName = process.env.REACT_APP_CURIOBITES_AWS_STORAGE_BUCKET_NAME;

    if (!bucketName) {
        console.error("Bucket name is undefined");
        return null; // or handle this case as you see fit
    }

    const params = {
        Bucket: bucketName,
        Key: "UserUploads/" + fileName,
        Body: file,
        ContentType: file.type,
    };

    const upload = s3.upload(params);

    upload.on('httpUploadProgress', (progress) => {
        const percentCompleted = Math.round((progress.loaded / progress.total) * 100);
        onProgress(percentCompleted);
    });

    try {
        const data = await upload.promise();
        // console.log('File uploaded successfully.', data.Location);
        return data
    } catch (error) {
        console.error('Error uploading file:', error);
        return null
    }

};




